import { Route, Routes } from "react-router-dom";
import { TeamGrid } from "./TeamGrid";
import { TeamPage } from "./TeamPage";

export const Teams: React.FC = () => {
  return (
    <Routes>
      <Route index element={<TeamGrid />} />
      <Route path=":teamId" element={<TeamPage />} />
    </Routes>
  );
};
